export default __webpack_public_path__ + "static/SRUS SP50 - Especification Del Producto y Datos Técnicos-6e390b2e4341055846cc09e5f119ade7.pdf";